import { CDNImage } from '../../common/interfaces/cdnImage';
import { TaskTileStyleConfig } from './SurveyTaskList';
import { TaskItemState, WorkflowItem, WorkflowItemType, ItemStatus } from '../../store/interfaces';
import { ValidateAssessmentLaunchConfig } from '../../assessment/interfaces';

export interface TaskItem extends Partial<TaskItemState>, Partial<WorkflowItem> {
  id: string;
  name?: string;
  code: WorkflowItemType;
  targetUrl?: string;
  status?: ItemStatus;
  taskDate?: string;
  ReportAvailableToManager?: boolean;
  isNew?: boolean;
}
export interface Task {
  id: number;
  title: string;
  subtitle?: string;
  description?: string;
  bannerColor?: string;
  bannerImageEnabled?: boolean;
  bannerImage?: CDNImage | null;
  duration?: number;
  items: TaskItem[];
  status?: ItemStatus;
  isSchedulable?: boolean;
  raterStats?: RaterStats;
}

export interface RaterStats {
  EnableFociRaterNominationStatus: boolean;
  QuestStatus: number;
  RaterID: number;
  endDate: string | null;
  proId: number;
  rStatus: number;
  raterStatus?: RaterStatus;
  ratingId: string;
  ratingids: RatingIDs[];
  taskState: ItemStatus;
  isLocked: boolean;
}

export interface RaterStatus {
  completedRaters: number;
  totalRaters: number;
  UIMode: string | null;
}

export interface RatingIDs {
  endDate: string | null;
  rStatus: number;
  ratingId: number;
}

export type RaterNominationPageMode = 'VIEW' | 'EDIT' | 'LOCK' | '';

export enum MODE {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  LOCK = 'LOCK',
}

export interface RaterNominationTaskStatus {
  ratingId: string;
  endDate: string | null;
  QuestStatus: number;
  proId: number;
  RaterID: number;
  rStatus: number;
  EnableFociRaterNominationStatus: boolean;
  ratingids: RatingIDs[];
  taskState: ItemStatus;
  isLocked: boolean;
}

export interface TaskTileProps {
  isTaskLocked?: boolean;
  task: Task;
  isSequentiallyLocked?: boolean;
  tiles: TaskTileStyleConfig;
  variant: string;
  pageStartTime: Date;
  initializeTask(task: Task, launchAssessmentConfig?: ValidateAssessmentLaunchConfig): Promise<void>;
}

export interface UserAllTaskDetails {
  ratingId: string;
  taskDate: string;
  isNew: boolean;
  code: string;
}

export interface MergeTaskDetails {
  rnTaskStatus?: RaterNominationTaskStatus[];
  userAllTaskDetails: UserAllTaskDetails[];
  tasks: Task[];
}
